import { LinkChildren, ButtonLink } from "../components/button";
import { Image } from "../components/media";

import { logingOut } from "../actions/authActions";

function AdminSidebar() {
  return (
    <div className="leftbar leftbar-dark">
      <div className="sidebar">
        <div className="logobar">
          <LinkChildren href="/admin" extraClass="logo logo-large">
            <Image src="logo_cropped.png" />
          </LinkChildren>

          <LinkChildren href="/admin" extraClass="logo logo-small">
            <Image src="logo_cropped.png" />
          </LinkChildren>
        </div>
        <div className="navigationbar">
          <ul className="vertical-menu">
            <li>
              <a href="#!">
                <Image src="svg-icon/dashboard.svg" />
                <span>Dashboard</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin"
                    text="Inicio"
                    extraClass="button-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <i className="feather icon-package"></i>

                <span>Paquetes</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin/paquetes"
                    text="Listado"
                    extraClass="button-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <i className="feather icon-package"></i>

                <span>Articulos</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin/articulos/recepcion"
                    text="Recepcion"
                    extraClass="button-link"
                  />
                </li>
                <li>
                  <ButtonLink
                    href="/admin/articulos"
                    text="Listado"
                    extraClass="button-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <i className="feather icon-users"></i>

                <span>Clientes</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin/clientes"
                    text="Todos"
                    extraClass="button-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <i className="feather icon-user"></i>

                <span>Usuarios</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin/usuarios"
                    text="Todos"
                    extraClass="button-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <i className="feather icon-plus-square"></i>
                <span>Herramientas</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin/tools/calculator"
                    text="Calculadora"
                    extraClass="button-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <Image src="svg-icon/user.svg" />

                <span>Cuenta</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/admin/account"
                    text="Perfil"
                    extraClass="button-link"
                  />
                </li>
                <li>
                  <ButtonLink
                    href="/admin/account/notificaciones"
                    text="Notificaciones"
                    extraClass="button-link"
                  />
                </li>
                <li>
                  <a
                    href="#!"
                    onClick={() => {
                      logingOut();
                    }}
                  >
                    Cerrar sesi&oacute;n
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AdminSidebar;
